import { Controller } from "@hotwired/stimulus";

// An unread message is marked as read as soon as one of its links (the sender,
// the event, ...) is followed. The request must survive the page being left.
export default class extends Controller {
  static values = {url: String};

  mark(event) {
    if (!event.target.closest("a")) return;
    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      credentials: "same-origin",
      headers: {"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content},
    });
  }
}
